var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCableCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7474 1.93776C18.7818 2.35054 18.4751 2.71305 18.0623 2.74745L12.75 3.19014V6.00004H18C19.1046 6.00004 20 6.89547 20 8.00004V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V8.00004C4 6.89547 4.89543 6.00004 6 6.00004H11.25V3.31514L6.06228 3.74745C5.6495 3.78185 5.28699 3.47511 5.25259 3.06233C5.21819 2.64954 5.52493 2.28703 5.93772 2.25263L17.9377 1.25263C18.3505 1.21823 18.713 1.52497 18.7474 1.93776ZM7 8.00004C6.44772 8.00004 6 8.44776 6 9.00004V16C6 16.5523 6.44771 17 7 17H17C17.5523 17 18 16.5523 18 16V9.00004C18 8.44776 17.5523 8.00004 17 8.00004H7ZM7.25 19.5C7.25 19.9143 7.58579 20.25 8 20.25H16C16.4142 20.25 16.75 19.9143 16.75 19.5C16.75 19.0858 16.4142 18.75 16 18.75H8C7.58579 18.75 7.25 19.0858 7.25 19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCableCar);
export default __webpack_public_path__ + "static/media/cable-car.6726a13c06e5a0ca398ea85e40607670.svg";
export { ForwardRef as ReactComponent };